import { render, staticRenderFns } from "./PanelWithTagGroupDisplay.vue?vue&type=template&id=69433321&lang=pug&"
import script from "./PanelWithTagGroupDisplay.vue?vue&type=script&lang=ts&"
export * from "./PanelWithTagGroupDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithTagGroupDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports